export const STATUS_AGENT = {
  ACTIVE: "active",
  INACTIVE: "inactive",
}

export const STATUS_LABEL = {
  [STATUS_AGENT.ACTIVE]: "Habilitado",
  [STATUS_AGENT.INACTIVE]: "Desabilitado",
}